module.exports = __webpack_public_path__ + "img/图片12.ef6b1935.png";